import sharedRouteNames from "@/shared/router/routeNames";

export default {
  ...sharedRouteNames,
  companyDocumentsUpload: "company-documents-upload",
  corporateKYCWelcome: "corporate-kyc-welcome",
  questionnaireCorporate: "questionnaire-corporate",
};
